import { REGISTRATION } from '@routes/path'

let logoutPath = REGISTRATION.LOGIN.DEFAULT

export const getLogoutPath = () => logoutPath

export const setLogoutPath = (path: string) => {
  logoutPath = path
}
